import { WipayTicketPrintArray } from '@payment-terminals/interfaces/wipay';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-wipay-ticket',
  components: {},
})
export default class WipayTicket extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly ticket: WipayTicketPrintArray;

  get ticketBodyRows(): string[] {
    return this.ticket.map(item => {
      return item[1] || '';
    });
  }

  get preformattedTicketString(): string {
    return `\n${this.ticketBodyRows.join('\n')}`;
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
